var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);

// utils/logger.ts
import { logger, setClientTransmit } from "@adornis/base/logging.js";
import { Int } from "../baseqlTypes.js";
import { Arg, Entity, Field, Mutation } from "../decorators.js";
import { AdornisEntity } from "../entities/adornisEntity.js";
import { registerMutation } from "../metadata/register.js";
var Log = class extends AdornisEntity {
  static fromLogEvent(event) {
    const messages = event.messages.map((m) => JSON.stringify(m));
    const bindings = event.bindings.map((m) => JSON.stringify(m));
    return new Log({ level: event.level.label, levelValue: event.level.value, ts: event.ts, messages, bindings });
  }
  static sendLogToServer(log) {
    return sendLogTOServerResolver(log);
  }
};
Log._class = "Log";
__decorateClass([
  Field((type) => String)
], Log.prototype, "level", 2);
__decorateClass([
  Field((type) => Int)
], Log.prototype, "levelValue", 2);
__decorateClass([
  Field((type) => Date)
], Log.prototype, "ts", 2);
__decorateClass([
  Field((type) => [String])
], Log.prototype, "messages", 2);
__decorateClass([
  Field((type) => [String])
], Log.prototype, "bindings", 2);
__decorateClass([
  Mutation((type) => Boolean),
  __decorateParam(0, Arg("log", (type) => Log))
], Log, "sendLogToServer", 1);
Log = __decorateClass([
  Entity()
], Log);
var sendLogTOServerResolver = (log) => {
  return () => {
    logger.info({
      source: "client",
      clientTs: log.ts.getTime(),
      clientLevel: log.levelValue,
      messages: log.messages.map((m) => JSON.parse(m)),
      ...Object.assign({}, ...log.bindings.map((b) => JSON.parse(b)))
    });
  };
};
var sendLogToServer = registerMutation({
  operationName: "sendLogToServer",
  resolve: sendLogTOServerResolver,
  type: () => Boolean,
  params: [{ name: "log", type: () => Log }]
});
var registerServerLogger = () => {
  setClientTransmit((level, logEvent) => {
    sendLogToServer(Log.fromLogEvent(logEvent))();
  });
};
export {
  Log,
  registerServerLogger,
  sendLogToServer
};
